import {
  ApplicationConfig,
  DEFAULT_CURRENCY_CODE,
  LOCALE_ID,
  importProvidersFrom,
} from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';

import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BarChart, LineChart, PieChart } from 'echarts/charts';
import { GridComponent, LegendComponent, TooltipComponent } from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { provideEchartsCore } from 'ngx-echarts';
import { NgxMaskPipe, provideEnvironmentNgxMask } from 'ngx-mask';
import { ToastrModule } from 'ngx-toastr';

import { routes } from 'src/app/app.routes';
import { APIErroInterceptor } from 'src/app/shared/interceptors/api-erro.interceptor';
import { LoaderInterceptor } from 'src/app/shared/interceptors/loader.interceptor';
import { TokenInterceptor } from 'src/app/shared/interceptors/token.interceptor';
import { LoaderService } from 'src/app/shared/services/utils/loader.service';

registerLocaleData(localePt, 'pt');
echarts.use([
  BarChart,
  GridComponent,
  CanvasRenderer,
  LegendComponent,
  TooltipComponent,
  LineChart,
  PieChart,
]);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withHashLocation()),
    [provideEchartsCore({ echarts })],
    provideEnvironmentNgxMask({
      decimalMarker: ',', // Use comma as the decimal separator
      thousandSeparator: '',
    }),
    importProvidersFrom(
      HttpClientModule,
      HttpClientJsonpModule,
      BrowserModule,
      BrowserAnimationsModule,
      BsDropdownModule.forRoot(),
      ModalModule.forRoot(),
      ToastrModule.forRoot({
        timeOut: 1000,
        positionClass: 'toast-top-right',
      })
    ),
    LoaderService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: APIErroInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: DEFAULT_CURRENCY_CODE,
      useValue: 'BRL',
    },
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR',
    },
    { provide: NgxMaskPipe },
  ],
};
